export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref15009.e261e0b8.jpg";